/* src/pages/mail/MailDetailsWrapper.js */
import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import MailDetails from "./components/MailDetails";

const MailDetailsWrapper = () => {
  return (
    <>
      <Sidebar />
      <MainSection>
        <SectionHeader title="Mail Details" />
        <DatatableSection>
          <MailDetails />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default MailDetailsWrapper;